import { api, method } from '../api/apiClient';

// export const getActiveOrders = async (hotelId) => {
//     try {
//         return await api(method.GET, `/order/active?hotelId=${hotelId}`);
//     } catch (error) {
//         console.error(`Error while getting active orders ${error}`);
//         throw error;
//     }
// };

export const getCompletedOrders = async ({
    hotelId,
    skip = 0,
    limit = 10,
    sortKey = '',
    sortOrder = '',
    filterKey = '',
    filterValue = ''
}) => {
    try {
        const query = `skip=${skip}&limit=${limit}&sortKey=${sortKey}&sortOrder=${sortOrder}&filterKey=${filterKey}&filterValue=${filterValue}`;
        return await api(method.GET, `/order/completed/${hotelId}?${query}`);
    } catch (error) {
        console.error(`Error while getting completed order details ${error}`);
        throw error;
    }
};

// export const updateOrdersStatus = async (payload) => {
//     try {
//         return await api(method.PUT, `/order`, payload);
//     } catch (error) {
//         console.error(`Error while updating pending order details ${error}`);
//         throw error;
//     }
// };

export const feedback = async (payload) => {
    try {
        return await api(method.PDF, `/order/feedback`, payload, { responseType: 'arraybuffer' });
    } catch (error) {
        console.error(`Error while sending order feedback ${error}`);
        throw error;
    }
};

// export const assignManager = async (payload) => {
//     try {
//         return await api(method.PUT, `/order/manager`, payload);
//     } catch (error) {
//         console.error(`Error while assigning order managers ${error}`);
//         throw error;
//     }
// };

export const getOrderStatus = async (customerId) => {
    try {
        return await api(method.GET, `/order/status/${customerId}`);
    } catch (error) {
        console.error(`Error while getting order status ${error}`);
        throw error;
    }
};
